export default {
  title: "مدیریت About us",
};
